import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import './Careers.css';

const Careers = () => {
  const jobListings = [
    {
      id: 1,
      title: 'Solar Installation Engineer',
      department: 'Engineering',
      location: 'Ahmedabad / Gujarat',
      type: 'Full-time',
      experience: '3+ years',
      salary: '₹8,00,000 - ₹12,00,000',
      description: 'Lead solar installation projects from design to commissioning. Ensure safe and efficient installation of residential and commercial solar systems.',
      requirements: [
        'Bachelor\'s degree in Electrical Engineering or related field',
        '3+ years of experience in solar installation or electrical systems',
        'Knowledge of solar PV systems, inverters, and electrical codes',
        'Experience with AutoCAD and solar design software',
        'Strong project management and communication skills'
      ],
      posted: '2024-01-15'
    },
    {
      id: 2,
      title: 'Solar Sales Executive',
      department: 'Sales',
      location: 'Surat / Gujarat',
      type: 'Full-time',
      experience: '2+ years',
      salary: '₹5,00,000 - ₹8,00,000',
      description: 'Drive solar energy sales by consulting with customers, conducting site assessments, and developing customized solar solutions.',
      requirements: [
        'Bachelor\'s degree in Engineering, Business, or related field',
        '2+ years of sales experience, preferably in renewable energy',
        'Strong understanding of solar energy systems and benefits',
        'Excellent communication and presentation skills',
        'Ability to work independently and meet sales targets'
      ],
      posted: '2024-01-12'
    },
    {
      id: 3,
      title: 'Solar Project Manager',
      department: 'Operations',
      location: 'Rajkot / Gujarat',
      type: 'Full-time',
      experience: '5+ years',
      salary: '₹10,00,000 - ₹15,00,000',
      description: 'Manage large-scale solar projects from planning to completion, ensuring quality, timeline, and budget compliance.',
      requirements: [
        'Bachelor\'s degree in Engineering or Project Management',
        '5+ years of project management experience in solar or construction',
        'PMP certification preferred',
        'Experience with commercial and industrial solar installations',
        'Strong leadership and organizational skills'
      ],
      posted: '2024-01-10'
    },
    {
      id: 4,
      title: 'Solar System Designer',
      department: 'Design',
      location: 'Vadodara / Gujarat',
      type: 'Full-time',
      experience: '3+ years',
      salary: '₹6,00,000 - ₹9,00,000',
      description: 'Design optimal solar energy systems using industry-standard software and ensure compliance with local regulations.',
      requirements: [
        'Bachelor\'s degree in Electrical Engineering or related field',
        '3+ years of solar system design experience',
        'Proficiency in PVsyst, AutoCAD, and SketchUp',
        'Knowledge of electrical codes and solar regulations',
        'Strong analytical and problem-solving skills'
      ],
      posted: '2024-01-08'
    },
    {
      id: 5,
      title: 'Solar Technician',
      department: 'Installation',
      location: 'Gandhinagar / Gujarat',
      type: 'Full-time',
      experience: '1+ years',
      salary: '₹3,50,000 - ₹5,50,000',
      description: 'Install, maintain, and repair solar panel systems on residential and commercial properties with focus on safety and quality.',
      requirements: [
        'ITI or Diploma in Electrical Engineering',
        '1+ years of electrical or solar installation experience',
        'Knowledge of electrical wiring and safety procedures',
        'Physical fitness for rooftop work and lifting equipment',
        'Willingness to travel to various installation sites'
      ],
      posted: '2024-01-05'
    },
    {
      id: 6,
      title: 'Business Development Manager',
      department: 'Business Development',
      location: 'Ahmedabad / Gujarat',
      type: 'Full-time',
      experience: '4+ years',
      salary: '₹12,00,000 - ₹18,00,000',
      description: 'Develop strategic partnerships and expand market presence in the renewable energy sector across Gujarat and neighboring states.',
      requirements: [
        'MBA or Bachelor\'s degree in Business, Engineering, or related field',
        '4+ years of business development experience in renewable energy',
        'Strong network in solar industry and government relations',
        'Excellent negotiation and strategic planning skills',
        'Experience with large commercial and industrial clients'
      ],
      posted: '2024-01-03'
    }
  ];

  const benefits = [
    {
      icon: 'fas fa-solar-panel',
      title: 'Solar Industry Leader',
      description: 'Work with Gujarat\'s leading solar energy company with over 5MW of installations and cutting-edge technology'
    },
    {
      icon: 'fas fa-leaf',
      title: 'Green Mission Impact',
      description: 'Be part of India\'s renewable energy revolution and contribute to a sustainable future for generations'
    },
    {
      icon: 'fas fa-tools',
      title: 'Advanced Solar Training',
      description: 'Get certified in the latest solar technologies, Australian smart inverters, and Make in India solar panels'
    },
    {
      icon: 'fas fa-chart-line',
      title: 'Growing Solar Market',
      description: 'Join the fastest-growing renewable energy sector with unlimited career advancement opportunities'
    },
    {
      icon: 'fas fa-award',
      title: 'Solar Expertise Recognition',
      description: 'Work with MNRE-certified engineers and gain recognition as a solar energy professional'
    },
    {
      icon: 'fas fa-handshake',
      title: 'Solar Community',
      description: 'Join a passionate team of solar professionals dedicated to clean energy solutions across Gujarat'
    }
  ];

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  const getDaysAgo = (dateString) => {
    const date = new Date(dateString);
    const today = new Date();
    const diffTime = Math.abs(today - date);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  return (
    <>
      <Helmet>
        <title>Solar Energy Careers - Join Global Solar Energy Team</title>
        <meta name="description" content="Join our team of solar energy professionals. Explore career opportunities in solar engineering, sales, installation, and project management. Build your career in renewable energy." />
        <meta name="keywords" content="solar careers, renewable energy jobs, solar engineer, solar technician, solar sales, gujarat jobs" />
      </Helmet>

      <div className="careers-page">
        {/* Hero Section */}
        <section className="careers-hero" style={{backgroundImage: `url('/images/Hero image/Careerpag.jpeg')`}}>
          <div className="careers-hero-overlay"></div>
          <div className="careers-hero-content">
            <h1 className="careers-hero-title">Careers</h1>
          </div>
        </section>

        {/* Why Work With Us */}
        <section className="section why-work-section">
          <div className="container">
            <div className="section-header text-center">
              <h2>Why Work With Us?</h2>
              <p>We believe in creating an environment where our team can thrive and do their best work</p>
            </div>
            <div className="benefits-grid">
              {benefits.map((benefit, index) => (
                <div key={index} className="benefit-card">
                  <div className="benefit-icon">
                    <i className={benefit.icon}></i>
                  </div>
                  <h3>{benefit.title}</h3>
                  <p>{benefit.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Company Culture */}
        <section className="section culture-section">
          <div className="container">
            <div className="culture-content">
              <div className="culture-text">
                <h2>Our Culture</h2>
                <p>
                  We foster a culture of innovation, sustainability, and continuous learning.
                  Our team is passionate about renewable energy and committed to delivering
                  exceptional solar solutions for our customers.
                </p>
                <p>
                  We believe in work-life balance, professional growth, and creating an 
                  inclusive environment where everyone can contribute their best work. 
                  Join us and be part of a team that values creativity, integrity, and excellence.
                </p>
                <div className="culture-stats">
                  <div className="culture-stat">
                    <div className="stat-number">75+</div>
                    <div className="stat-label">Team Members</div>
                  </div>
                  <div className="culture-stat">
                    <div className="stat-number">25+</div>
                    <div className="stat-label">Cities in Gujarat</div>
                  </div>
                  <div className="culture-stat">
                    <div className="stat-number">98%</div>
                    <div className="stat-label">Employee Satisfaction</div>
                  </div>
                </div>
              </div>
              <div className="culture-image">
                <img src="/images/gallery/17.jpeg" alt="Our team culture - Solar professionals at work" loading="lazy" />
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="section section-alt cta-section">
          <div className="container">
            <div className="cta-content text-center">
              <h2>Don't See the Right Position?</h2>
              <p>
                We're always interested in hearing from talented individuals. 
                Send us your resume and let us know how you'd like to contribute to our team.
              </p>
              <div className="cta-buttons">
                <Link to="/contact" className="btn btn-primary">
                  Send Your Resume
                </Link>
                <a href="mailto:globalsolar99@gmail.com" className="btn btn-outline">
                  Email Us Directly
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Careers;